<template>
  <div class="h-full rounded-lg flex flex-col gap-2">
    <div class="flex flex-col gap-2 overflow-y-auto scrollbar-thin scrollbar-tema">
      <AppFilterForm :tabela="tabela" :visibility="show_form_filter" @close="closeFilterForm" />
      <div class="flex flex-col md:flex-row gap-2">
        <AppFornecedorForm :show="show_form" :disable_visibility="true" :update_visibility="true"
          :form_title="form_title" :form_data="fornecedor_formData" :create_btn="create_fornecedor_"
          :set_data="fornecedor_setData" @close="closeForm" @show_table="show_form_table" @create="create_fornecedor"
          @update="update_fornecedor" @disable="disable_fornecedor" />

        <AppTable :visibility="true" :show="show_generic_table" :table_data="generic_table_data"
          :table_title="generic_table_title" @row-clicked="select_generic_row" @close="close_generic_table"
          with_confirmation="true" />

          <AppTablePagination
            v-if="show_artigos"
            :visibility="true"
            :show="show_artigos"
            :table_title="'Artigos do Fornecedor'"
            :groupby="{show:true, field:'equipamento'}"
            @row-clicked=""
            @close="close_artigos"
            :urlString="`artigo/fornecedor/${fornecedor.id}`"
            :refresh="refresh"
            @refreshed="refresh = false"
          />

        <AppGenericCrud v-if="show_crud" :model="crud.crud_model" :data="{
          title: crud.crud_title,
          entity_type: crud.crud_type,
          key_name: crud.crud_type + '_id',
          rotas: {
            create_url: `${baseURl}/api/v1/${crud.crud_type}/registrar/`,
            select_all_url: `${baseURl}/api/v1/fornecedor/${fornecedor.id}/?${crud.crud_type}_only=true`,
            select_url: `${baseURl}/api/v1/${crud.crud_type}/`,
            update_url: `${baseURl}/api/v1/${crud.crud_type}/editar`,
            delete_url: `${baseURl}/api/v1/${crud.crud_type}/eliminar`,
          },
          owner: {
            id: fornecedor.id,
            key_name: 'fornecedor_id',
            type: 'fornecedor',
            multiTable: true,
            rotas: {
              create_url: `${baseURl}/api/v1/fornecedor_${crud.crud_type}/registrar/`,
            },
          },
        }" :types="crud.types" :set_data="crud.crud_set_data" :set_id="crud.crud_set_id"
          :with_address="crud_with_address" @close="close_crud" />
        <AppOrcamentoForm v-if="show_orcamento" :fornecedor="fornecedor" @close="close_orcamento()" />

        <AppPrecoForm v-if="show_preco" :fornecedor="fornecedor" @close="close_preco()" />

        <!-- <AppAddressMap v-if="show_address" :address="fornecedor?.endereco" @close="close_address()" /> -->
        <AppAddressMap v-if="show_address" :initialAddress="fornecedor_endereco" @close="close_address()"
          @save="update_address" />

        <AppEncomendaForm v-if="show_encomenda" :entities="[
          { id: fornecedor.id, nome: fornecedor.nome, entity: 'fornecedor' },
          { id: 0, numero: 'Não Atribuido', entity: 'orçamendo' },
        ]" @close="close_encomenda()" />

        <AppProdutoForm v-if="show_produto" @close="close_produto()" />


        <!-- <Faturacao2 v-if="show_faturacao"  /> -->
        <Faturacao2 v-if="false" @close="close_faturacao()" />

        <AppFaturacaoForm :propsData="{
          fornecedor_id: fornecedor_formData.id,
          other_test: 'kkkk',
        }"  

        v-if="show_faturacao"

         :entities="[
            { id: fornecedor.id, nome: fornecedor.nome, entity: 'fornecedor' },
            // {id:0, numero:'Não Atribuido', entity:'orçamendo'},
          ]" @close="close_faturacao()" />

        <AppRecolha_EntregaForm v-if="show_recolha_entrega" :entities="[
          { id: fornecedor.id, nome: fornecedor.nome, entity: 'fornecedor' },
          // {id:0, numero:'Não Atribuido', entity:'orçamendo'},
        ]" @close="close_recolha_entrega()" />
      </div>
      <div class="w-full">
        <!-- <AppTable :visibility="this.validPermission('F0006')" :show="show_table" :table_data="fornecedores"
          :table_title="table_title" @row-clicked="select_fornecedor" @close="close_table"
          @delete_data="remove_fornecedor" /> -->

          <AppTablePagination
            :visibility="validPermission('F0006')"
            :show="show_table"
            :table_title="table_title"
            :AddRemoveBtn="{
              verAdicionar: validPermission('F0018'),
            }"
            @open-adicionar="triggerAction({ action: 'create_fornecedor' })"
            @row-clicked="select_fornecedor"
            :refresh="refresh" @refreshed="refresh = false"
            urlString="fornecedor"
            :filterData="filtroData"
            :order_by="order_by"
            :page_size="page_size"
        />

      </div>
    </div>
  </div>
</template>

<script>
import { id as loggedID } from "@/extraData";

import axios from "axios";
import AppTable from "@/components/tables/table.vue";
import AppInfoCard from "@/components/infoCard.vue";
import AppProfileSearch from "@/components/profileSearch.vue";
import AppSearch from "@/components/search.vue";
import AppNotification from "@/components/notification.vue";
import AppButton from "@/components/updated/button.vue";
import AppForm from "@/components/form.vue";
import AppFornecedorForm from "@/components/forms/fornecedor/fornecedorForm.vue";
import AppFilter from "@/components/filter/filter.vue";
import AppFilterForm from "@/components/filter/filterForm.vue";
import AppGenericCrud from "@/components/genericCRUD_final.vue";
import AppOrcamentoForm from "@/components/forms/fornecedor/orcamento.vue";
import AppPrecoForm from "@/components/forms/fornecedor/preco.vue";
//import AppPrecoForm from '@/components/tabelaPrecoForm.vue'
import AppAddressMap from "@/components/addressMap.vue";
import AppEncomendaForm from "@/components/forms/fornecedor/encomenda.vue";
import AppProdutoForm from "@/components/forms/fornecedor/produto.vue";
import AppFaturacaoForm from "@/components/forms/fornecedor/faturacao.vue";
import AppRecolha_EntregaForm from "@/components/forms/fornecedor/recolha_entrega.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import { toast } from "vue3-toastify";
import { toHandlers } from "vue";
import permissionMixin from "@/permissionMixin.js";
import Faturacao2 from '@/components/forms/fornecedor/faturacao_v2.vue'
import AppTablePagination from '@/components/tablePagination/tablePagination.vue';

export default {
  mixins: [permissionMixin],
  name: "appfornecedores",
  components: {
    AppTablePagination,
    AppTable,
    AppInfoCard,
    AppForm,
    AppFilter,
    AppProfileSearch,
    AppSearch,
    AppNotification,
    AppFornecedorForm,
    AppButton,
    AppFilterForm,
    AppGenericCrud,
    AppOrcamentoForm,
    AppPrecoForm,
    AppAddressMap,
    AppEncomendaForm,
    AppProdutoForm,
    AppFaturacaoForm,
    AppRecolha_EntregaForm,
    Faturacao2
  },
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      loggedID: loggedID,
      fornecedores: [],
      fornecedor: {},
      armazens: [],
      armazem_tipos: [],
      zona_tipos: [],
      contacto_tipos: [],
      crud: {
        crud_title: "",
        crud_type: "",
        crud_model: {},
        crud_set_data: {},
        crud_set_id: {},
        crud_types: {},
      },
      produtos: [],
      tabela_precos: [],
      orcamentos: [],
      precos: [],
      encomenda: [],
      faturacao: [],
      fornecedor_endereco: {},
      generic_table_data: [],
      generic_table_title: "Generic Table",
      current_table: "none",
      refresh: false,
      show_form: false,
      show_table: true,
      show_action_card: true,
      show_generic_table: false,
      show_artigos: false,

      show_crud: false,
      show_orcamento: false,
      show_preco: false,
      show_address: false,
      show_encomenda: false,
      show_produto: false,
      show_faturacao: false,
      show_recolha_entrega: false,

      form_title: "No Title",

      create_fornecedor_: false,
      crud_with_address: false,

      filter_data: [
        {
          filter_name: "Dashboard",
          filter_visibility: true,
          filter_selected: true,
        },
        {
          filter_name: "Instalações",
          filter_visibility: true,
          filter_selected: false,
        },
        {
          filter_name: "Preços",
          filter_visibility: true,
          filter_selected: false,
        },
        {
          filter_name: "Empresa",
          filter_visibility: true,
          filter_selected: false,
        },
      ],

      fornecedor_formData: {},
      fornecedor_setData: {},

      //   FilterForm data
      filtroData: {},
      show_form_filter: false,
      selectedFiltro: "",
      filtroOptions: [],

      tabela: "fornecedor",
      table_title: "Fornecedores",

      crud_create_url: "",
      crud_select_all_url: "",
      crud_update_url: "",
      crud_delete_url: "",
    };
  },
  created() {
    //this.clear_fornecedor_endereco();
    this.get_fornecedores();
    this.getTypes();
    this.setfornecedorForm(null);
  },
  methods: {
      async fetchArtigos() {
      try {
        const response = await axios.get(
          `${this.baseURl}/api/v1/fornecedor_artigo/s/fornecedor_id/${this.fornecedor.id}/?exact=true`
        );
        this.generic_table_data = response.data.data.map((item) => ({
          id: item.id,
          data: item.data || "N/A",
          Artigo: item.artigo_id || "N/A",
          status: item.status || "N/A",
        }));
      } catch (error) {
        console.error("Erro ao buscar artigos:", error);
        toast.error("Erro ao buscar artigos", {
          autoClose: 1000,
        });
      }
    },
    async get_fornecedores() {
      // const res = await this.select_all(`${this.baseURl}/api/v1/fornecedor/`);
      // console.log("fornecedores:", res);
      // if (res) {
      //   let modified_fornecedores = res.map((value) => ({
      //     id: value.id,
      //     nome: value.nome,
      //     NIF: value.nif,
      //     nome_contato:
      //       value.contacto && value.contacto[0]?.nome
      //         ? value.contacto[0].nome
      //         : "N/A",
      //     telefone:
      //       value.contacto && value.contacto[0]?.telefone
      //         ? value.contacto[0].telefone
      //         : "N/A",
      //     email:
      //       value.contacto && value.contacto[0]?.email
      //         ? value.contacto[0].email
      //         : "N/A",
      //     telemovel:
      //       value.contacto && value.contacto[0]?.telemovel
      //         ? value.contacto[0].telemovel
      //         : "N/A",
      //     status: value.status ? value.status : "",
      //   }));

      //   console.log("modified_fornecedores:", modified_fornecedores);
      //   this.fornecedores = modified_fornecedores?.sort((a, b) => a.id - b.id);
      // }
      this.refresh = true;
    },
    

    async create_fornecedor(data) {
      console.log("view create_form_data:", data);

      let create_data = this.setData(data);
      console.log("fornecedor to create", create_data);

      const res = await this.create(
        create_data,
        `${this.baseURl}/api/v1/fornecedor/registrar/`
      );
      if (res) {
        data.id = res.id;

        toast.success("fornecedor criado com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        console.log("response:", res);
        await this.create_update_endereco("create", res);
        await this.get_fornecedores();
        await this.getTypes();
        await this.upload_img(data);
        this.closeForm();
        this.show_table = true;
      
      } else {
        toast.error("Erro ao criar fornecedor", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },

    async select_fornecedor(data) {

      console.log("-----------------------------");
      console.log("fornecedor to select:", data);
      console.log("-----------------------------");

      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;

      this.closeAll();

      this.create_fornecedor_ = false;
      this.form_title = "Informação Do fornecedor";
      const fornecedor = await this.select(
        `${this.baseURl}/api/v1/fornecedor/${data.id}/`
      );
      this.fornecedor = JSON.parse(JSON.stringify(fornecedor));
      console.log("fornecedor:", fornecedor);
      if (fornecedor) {
        this.fornecedor_endereco = JSON.parse(
          JSON.stringify(fornecedor.endereco)
        );
        if (isEmptyObject(this.fornecedor_endereco)) {
          this.fornecedor_endereco.id = 0;
        }
        console.log("fornecedor_endereco:", this.fornecedor_endereco);
        this.setfornecedorForm(fornecedor);
        await this.get_imagem(fornecedor.id);
        this.show_form = true;
      }
    },

    async update_fornecedor(data) {
      console.log("fornecedor to update:", data);
      console.log("fornecedor address to update:", this.fornecedor_endereco);

      let update_data = this.setData(data);
      console.log("fornecedor ready to update", update_data);

      const res = await this.update(
        `${this.baseURl}/api/v1/fornecedor/editar/${data.id}/`,
        update_data
      );
      if (res) {
       
        console.log("fornecedor updated", res);

        toast.success("fornecedor atualizado com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });

        await this.create_update_endereco("update", res);
        await this.get_fornecedores();
        await this.getTypes();
        await this.upload_img(data);
        this.closeForm();
        this.show_table = true;
      } else {
        toast.error("Erro ao atualizar fornecedor", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },
    async remove_fornecedor(data) {
      console.log("fornecedor to remove:", data);
      const res = await this.remove(
        `${this.baseURl}/api/v1/fornecedor/eliminar/${data.id}/`
      );
      if (res) {
     
        this.closeForm();
        await this.get_fornecedores();
      }
    },

    closeForm() {
      this.show_form = false;
      this.closeAll();
    },
    closeAll() {
      this.close_generic_table();
      this.close_crud();
      this.close_orcamento();
      this.close_preco();
      this.close_address();
      this.close_encomenda();
      this.close_produto();
      this.close_faturacao();
      this.close_recolha_entrega();
      this.clear_fornecedor_endereco();
      this.close_artigos();
    },

    closeFilterForm() {
      this.show_form_filter = false;
    },

    close_table() {
      this.show_table = false;
    },

    close_artigos() {
      if(this.show_artigos){
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_artigos = false;
    },

    close_generic_table() {
      if (this.show_generic_table) {
        //this.show_generic_table=false;
        document.getElementById("right_form").style.display = "flex";
      }

      this.show_generic_table = false;
    },

    close_crud() {
      if (this.show_crud) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_crud = false;
    },

    close_orcamento() {
      if (this.show_orcamento) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_orcamento = false;
    },
    close_preco() {
      if (this.show_preco) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_preco = false;
    },
    close_address() {
      if (this.show_address) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_address = false;
    },

    close_encomenda() {
      if (this.show_encomenda) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_encomenda = false;
    },

    close_produto() {
      if (this.show_produto) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_produto = false;
    },
    close_faturacao() {
      if (this.show_faturacao) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_faturacao = false;
    },
    close_recolha_entrega() {
      if (this.show_recolha_entrega) {
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_recolha_entrega = false;
    },

    triggerAction(action) {
      // console.log("action to perform:", action)
      if (action.action === "create_fornecedor") {
        this.create_fornecedor_ = true;
        this.form_title = "Criar fornecedor";
        this.setfornecedorForm(null);

        this.closeAll();

        this.show_form = true;
      }
      if (action.action === "show_table") {
        this.show_table = true;
      }
      if (action.action === "criar_filtro") {
        this.show_form_filter = true;
      }
    },
    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        console.log("Data successfully updated:", res.data);
        return res.data.data;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },
    async remove(url) {
      // console.log("Data:", data.id)
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },
    async getTypes() {
      const armazens = await this.select_all(`${this.baseURl}/api/v1/armazem/`);

      const contato_tipos = await this.select_all(
        `${this.baseURl}/api/v1/tpcontacto/`
      );
      const armazem_tipos = await this.select_all(
        `${this.baseURl}/api/v1/tparmazem/`
      );
      const zona_tipos = await this.select_all(
        `${this.baseURl}/api/v1/tpzona/`
      );

      this.zona_tipos = zona_tipos.sort((a, b) => a.id - b.id);
      this.armazem_tipos = armazem_tipos.sort((a, b) => a.id - b.id);
      this.contacto_tipos = contato_tipos.sort((a, b) => a.id - b.id);
      this.armazens = armazens?.sort((a, b) => a.id - b.id);
      console.log("form_data:", this.fornecedor_formData);
    },

    setfornecedorForm(data) {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;
      this.fornecedor_formData = {
        id: data && data.id ? data.id : 0,
        nome: data && data.nome ? data.nome : "",
        nif: data && data.nif ? data.nif : "",
        descricao: data && data.descricao ? data.descricao : "",
        foto:
          data && data.foto
            ? data.foto
            : require("@/assets/default-profile-img.jpg"),
        status: data && data.status ? data.status : "desativo",
      };

      this.fornecedor_setData = {
        comercial:
          data && data.comercial && !isEmptyObject(data?.comercial)
            ? data.comercial
            : { id: 0, nome: "Não Atribuido" },
        endereco:
          data && data.endereco && !isEmptyObject(data?.endereco)
            ? data.endereco
            : { id: 0, pais: "N/A" },
      };
    },

    setData(data) {
      let prepared_data = {
        nome: data.nome || "",
        nif: data.nif || "",
        descricao: data.descricao || "",
        endereco_id: data?.endereco?.id || 0,
        comercial_id: data?.comercial?.id || 0,
        //armazem_id: data?.armazem?.id || 0,
      };
      return prepared_data;
    },

    show_form_table(data) {
      if (data === "contacto") {
        (this.crud.crud_model = {
          id: 0,
          nome: "",
          email: "",
          telefone: "",
          telemovel: "",
          descricao: "",
          // tipo:0,
          // tipos:this.contacto_tipos,
          // zonas:[{id:1, nome:'ponta agua'},{id:2, nome:'palmarejo'},{id:3, nome:'achada santo antonio'}],
          // zona:0,
        }),
          (this.crud.crud_title = "Contactos");
        this.crud.crud_type = "contacto";

        this.crud.types = {
          tipo: this.contacto_tipos,
        };
        this.crud.crud_set_data = {
          tipo: { id: 0, nome: "" },
        };
        this.crud.crud_set_id = {
          tipo: "tpContacto_id",
        };

        // this.crud_create_url=`${this.baseURl}/api/v1/contacto/registrar/`
        // this.crud_select_all_url=`${this.baseURl}/api/v1/fornecedor/${this.fornecedor.id}/?contacto_only=true/`
        // this.crud_update_url=`${this.baseURl}/api/v1/contacto/editar`
        // this.crud_delete_url=`${this.baseURl}/api/v1/contacto/eliminar`

        this.crud_with_address = false;

        this.show_crud = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "armazem") {
        (this.crud.crud_model = {
          id: 0,
          nome: "",
          descricao: "",
          // tipo:0,
          // tipos:this.armazem_tipos
        }),
          (this.crud.crud_title = "Armazens");
        this.crud.crud_type = "armazem";

        this.crud.types = {
          tipo: this.armazem_tipos,
          zona: this.zona_tipos,
        };
        this.crud.crud_set_data = {
          tipo: { id: 0, nome: "" },
          zona: { id: 0, nome: "" },
        };
        this.crud.crud_set_id = {
          tipo: "tpArmazem_id",
          zona: "tpZona_id",
        };

        // this.crud_create_url=`${this.baseURl}/api/v1/armazem/registrar/`
        // this.crud_select_all_url=`${this.baseURl}/api/v1/fornecedor/${this.fornecedor.id}/?armazem_only=true/`
        // this.crud_update_url=`${this.baseURl}/api/v1/armazem/editar`
        // this.crud_delete_url=`${this.baseURl}/api/v1/armazem/eliminar`

        this.crud_with_address = true;

        this.show_crud = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "mapa") {
        this.show_address = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "orçamentos") {
        this.current_table = "Orçamentos";
        this.show_orcamento = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "encomenda") {
        this.current_table = "Encomendas";
        this.show_encomenda = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "preços") {
        this.current_table = "Preços";
        this.show_preco = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "artigo") {
        // this.current_table = "Artigos";
        // this.fetchArtigos();
        // this.generic_table_title = "Artigos do Fornecedor";
        // this.show_generic_table = true;
        this.show_artigos=true;
        this.refresh = true;  
        document.getElementById("right_form").style.display = "none";
      } else if (data === "produtos") {
        this.current_table = "Produtos";
        this.show_produto = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "faturação") {
        this.current_table = "Faturação";
        this.show_faturacao = true;
        document.getElementById("right_form").style.display = "none";
      } else if (data === "recolha") {
        this.current_table = "Recolha";
        this.show_recolha_entrega = true;
        document.getElementById("right_form").style.display = "none";
      } else {
        const tableMappings = {
          // 'contacto': { data: this.fornecedor_contactos, title: 'Contactos' },
          // 'armazem': { data: this.armazens, title: 'Armazens' },
          //'preços': { data: [{Tarefa:'Ainda não implementada'}], title: 'Preços' },
          // 'produtos': { data: [{Tarefa:'Ainda não implementada'}], title: 'Produtos' },
          // 'faturação': { data:  [{Tarefa:'Ainda não implementada'}], title: 'Faturação' },
          // 'orçamentos': { data:  [{Tarefa:'Ainda não implementada'}], title: 'Orçamentos' },
          // 'encomenda': { data:  [{Tarefa:'Ainda não implementada'}], title: 'Encomendas' },
        };
        const mapping = tableMappings[data];
        if (mapping) {
          this.current_table = data;
          this.generic_table_data = mapping.data;
          this.generic_table_title = mapping.title;
          this.show_generic_table = true;
          document.getElementById("right_form").style.display = "none";
        }
      }
    },

    select_generic_row(data) {
      console.log("row selected:", data);
      console.log("current_table:", this.current_table);
      if (this.current_table == "armazem") {
        this.fornecedor_setData.armazem = data;
      } else if (this.current_table == "tipo") {
        this.fornecedor_setData.tipo_fornecedor = data;
      } else if (this.current_table == "utilizador") {
        this.fornecedor_setData.utilizador = data;
      } else if (this.current_table == "gps") {
        this.fornecedor_setData.gps = data;
      }
      this.close_generic_table();
    },

    async disable_fornecedor(data) {
      console.log("parent status:", data);
      let update_data = {
        nome: data.nome,
        status: data.status == "ativo" ? "desativado" : "ativo",
      };
      const res = await this.update(
        `${this.baseURl}/api/v1/fornecedor/editar/${data.id}/`,
        update_data
      );
      if (res) {
        console.log("fornecedor updated", res);
        const message = data.status == "ativo" ? "desativado" : "ativado";
        this.fornecedor_formData.status = update_data.status;
        toast.success(`fornecedor ${message} com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        await this.get_fornecedores();
      } else {
        const message = data.status == "ativo" ? "desativar" : "ativar";
        toast.error(`Erro ao ${message} fornecedor`, {
          autoClose: 1000,
        });
      }
      console.log("manutencao to add:", data);
    },

    async upload_img(formData) {
      if (formData.newFoto) {
        try {
          const response = await axios.post(
            `${this.baseURl}/api/v1/fornecedor/editar/foto/${formData.id}/`,
            formData.newFoto,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          const filePath = response.data.filePath;
          //this.formData.foto = filePath;
          // await this.get_imagem(formData.id);
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    },
    async get_imagem(id) {
      if (id == 0) return;
      try {
        const response = await axios.get(
          `${this.baseURl}/api/v1/fornecedor/foto/${id}/`,
          { responseType: "blob" }
        );
        // Create a local URL of the image
        if(response.status != 200) return;
        this.fornecedor_formData.foto = URL.createObjectURL(
          new Blob([response.data])
        );
      } catch (error) {
        console.log(error);
      }
    },

    update_address(data) {
      console.log("parent address:", data);
      this.fornecedor_setData.endereco = data;
      this.fornecedor_endereco = JSON.parse(JSON.stringify(data));
      this.close_address();
    },

    clear_fornecedor_endereco() {
      console.log("clearing fornecedor endereco");
      this.fornecedor_endereco = {
        pais: "",
        morada: "",
        codigoPostal: "",
        freguesia: "",
        localidade: "",
        latitude: "",
        longitude: "",
        concelho: "",
        distrito: "",
      };
    },

    async create_update_endereco(action, fornecedor) {
      console.log("endereco to create/update:", this.fornecedor_endereco);
      if (action == "create") {
        delete this.fornecedor_endereco.id;
        const res = await this.create(
          this.fornecedor_endereco,
          `${this.baseURl}/api/v1/endereco/registrar/`
        );
        if (res) {
          console.log("endereco created:", res);
          const updated_fornecedor = await this.update(
            `${this.baseURl}/api/v1/fornecedor/editar/${fornecedor.id}/`,
            { nome: fornecedor.nome, endereco_id: res.id }
          );
          if (updated_fornecedor) {
            console.log("fornecedor updated", updated_fornecedor);
          }
        } else {
          toast.error("Erro ao criar endereço", {
            autoClose: 1000,
          });
        }
      } else if (action == "update") {
        console.log("fornecedor to update:", fornecedor.id);
        if (this.fornecedor_endereco.id == 0) {
          const res = await this.create(
            this.fornecedor_endereco,
            `${this.baseURl}/api/v1/endereco/registrar/`
          );
          if (res) {
            console.log("endereco created:", res);
            const updated_fornecedor = await this.update(
              `${this.baseURl}/api/v1/fornecedor/editar/${fornecedor.id}/`,
              { nome: fornecedor.nome, endereco_id: res.id }
            );
            if (updated_fornecedor) {
              console.log("fornecedor updated", updated_fornecedor);
            } else {
              toast.error("Erro ao Criar endereço do fornecedor", {
                autoClose: 1000,
              });
            }
          } else {
            toast.error("Erro ao Criar endereço", {
              autoClose: 1000,
            });
          }
        } else {
          const res = await this.update(
            `${this.baseURl}/api/v1/endereco/editar/${this.fornecedor_endereco.id}/`,
            this.fornecedor_endereco
          );

          if (res) {
            console.log("endereco updated", res);
          } else {
            toast.error("Erro ao atualizar endereço", {
              autoClose: 1000,
            });
          }
        }
      }
    },

  },
  watch: {
    async selectedFiltro(newFiltro) {
      if (newFiltro) {
        this.filtroData = { ...newFiltro };
        delete this.filtroData.id;
        delete this.filtroData.status;
        this.show_table = true;
        this.table_title =
          this.filtroData.nome.charAt(0).toUpperCase() +
          this.filtroData.nome.slice(1).toLowerCase();
        const response = await axios.post(
          `${this.baseURl}/api/v1/filtro/testar/`,
          this.filtroData
        );
        this.fornecedores = response.data.data;
      } else {
        this.get_fornecedores();
        this.table_title = "Fornecedores";
        this.show_table = true;
      }
    },
  },
};
</script>

<style>
.scroll-style {
  overflow-y: auto;
  scrollbar-color: var(--scroll);
  scrollbar-width: thin;
}

.popup {
  position: fixed;
  display: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid black;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.popup-content {
  text-align: center;
}

.popup button {
  margin: 0 10px;
  padding: 5px 10px;
  cursor: pointer;
}

.btn {
  font-size: 12px;
  width: fit-content;
  padding: 0.5rem 0.8rem;
  color: white;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background-color: #626288;
}

.btn:hover {
  background-color: #c67700;
}

.text-white {
    color: var(--label);
}

.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
</style>
